import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AccountService } from '../services/account.service';
import { Dealer } from '../../shared/models/dealer.interface';
import { DealerTerm } from '../../shared/models/dealer-term.interface';
import { TextEdit } from '../models/text.edit.interface';
import { QuillToolbarConfig, QuillModule } from 'ngx-quill';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent extends AbstractBiditComponent {
  noteText: string;

  private _textType: string;
  private _locale: string;
  private _dealer: Dealer;


  @Input()
  public set textType(value: string) {
    if (value) {
      this._textType = value[0].toUpperCase() + value.substring(1);
      this.setNoteText();
    }
  }

  public get textType(): string {
    return this._textType;
  }

  @Input()
  public set locale(value: string) {
    this._locale = value ?? "en";
    this.setNoteText();
  }

  public get locale(): string {
    return this._locale;
  }

  @Input()
  public set dealer(value: Dealer) {
    this._dealer = value;
    this.setNoteText();
  }

  public get dealer(): Dealer {
    return this._dealer;
  }

  setNoteText() {
    let dealerTerm = this._dealer?.dealerTerms.find(dt => dt.locale == this._locale);
    if (dealerTerm == undefined) {
      this.noteText = '';
      return;
    }

    if (this._textType == 'Sales')
      this.noteText = dealerTerm.contractTerms;
    else if (this._textType == 'Contract')
      this.noteText = dealerTerm.contractAcceptance;
    else if (this._textType == 'Total')
      this.noteText = dealerTerm.totalSummary;
  }

  applyNoteText() {
    let dealerTerm = this._dealer?.dealerTerms.find(dt => dt.locale == this._locale);
    if (dealerTerm == undefined) {
      dealerTerm = {
        dealer_ID: this._dealer.dealer_ID,
        locale: this.locale,
        contractTerms: '',
        contractAcceptance: '',
        totalSummary: ''
      };
      this._dealer.dealerTerms.push(dealerTerm);
    }

    if (this._textType == 'Sales')
      dealerTerm.contractTerms = this.noteText;
    else if (this._textType == 'Contract')
      dealerTerm.contractAcceptance = this.noteText;
    else if (this._textType == 'Total')
      dealerTerm.totalSummary = this.noteText;
  }

  constructor(deviceDetectorService: DeviceDetectorService,
    private accountService: AccountService, private snackBar: MatSnackBar,
    private router: Router, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  saveText({ value, valid }: { value: TextEdit, valid: boolean }) {
    this.errors = '';

    if (value.noteText.length > 25000) {
      this.errors = 'Cannot save - text too long';
      return;
    }

    if (valid) {
      this.accountService.saveText(this._textType, this._locale, value)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
          if(result) {
            this.snackBar.open('Default Text Updated', null, {
              duration: 2000,
              verticalPosition: 'bottom',
              panelClass: ['bidit-snackbar']
            });
            console.log(result);
            this.applyNoteText();
          }
        },
          error: (error: string) => this.onError(error)
        });
    }
  }

}
